import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import RevealText from "../components/RevealText";
import ScrollReveal from "../components/ScrollReveal";
import TonalPanel from "../components/TonalPanel";
import { JOURNAL } from "../constants/testIds";

const COVERS = [
  { bg: "plum", tube: "#e6ddcf", cap: "light", sub: "LIP GLOSS" },
  { bg: "stone", tube: "#3a2530", cap: "same", sub: "LIP GLOSS" },
  { bg: "charcoal", tube: "#c9a37a", cap: "dark", sub: "LIP GLOSS" },
  { bg: "taupe", tube: "#141212", cap: "dark", sub: "LIP BALM" },
];

export default function Journal() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/journal").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="pt-32 md:pt-44">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-6 mb-16 md:mb-24">
        <div className="col-span-12 md:col-span-4">
          <p className="text-[10px] uppercase tracking-eyebrow text-ink/60">Correspondence</p>
          <p className="mt-2 text-[11px] uppercase tracking-editorial text-ink/70">Volume I · MMXXV — MMXXVI</p>
        </div>
        <div className="col-span-12 md:col-span-8">
          <RevealText
            as="h1"
            className="font-serif-display text-[13vw] md:text-[9vw] leading-[0.9] tracking-[-0.02em]"
            lines={["Journal", <span key="i" className="italic font-serif-italic">of the House</span>]}
          />
        </div>
      </div>

      <ul data-testid={JOURNAL.list} className="max-w-[1600px] mx-auto px-6 md:px-10">
        {items.map((a, i) => {
          const c = COVERS[i % COVERS.length];
          return (
            <ScrollReveal key={a.slug} delay={i * 0.06}>
              <li className="border-t border-ink/25 py-10 md:py-16">
                <Link to={`/journal/${a.slug}`} data-testid={JOURNAL.item(a.slug)} className="group grid grid-cols-12 gap-4 md:gap-10 items-center">
                  <div className="col-span-2 md:col-span-1 chapter-num text-plum text-2xl md:text-3xl">{a.chapter.replace("Chapter ","")}</div>
                  <div className="col-span-10 md:col-span-6">
                    <p className="text-[10px] uppercase tracking-editorial text-ink/60">{a.chapter} · {a.published} · {a.read_time}</p>
                    <h3 className="font-serif-display text-3xl md:text-6xl leading-[1.02] mt-3 max-w-[22ch]">{a.title}</h3>
                    <p className="mt-4 text-[15px] leading-[1.55] text-ink/70 max-w-[52ch]">{a.subtitle}</p>
                  </div>
                  <div className="col-span-12 md:col-span-5 md:col-start-8">
                    <TonalPanel
                      bg={c.bg}
                      tubeColor={c.tube}
                      cap={c.cap}
                      sublabel={c.sub}
                      fig={a.chapter}
                      caption={a.title}
                      chapter={a.published}
                      ratio="aspect-[4/3]"
                    />
                  </div>
                </Link>
              </li>
            </ScrollReveal>
          );
        })}
      </ul>
    </div>
  );
}
